import React from "react";

const Input = ({ ...rest }) => {
	return <input {...rest} className="form-control form--control" />;
};

export default Input;
